'use strict';

const Moment = require('moment');

export const isAdultPerson = function (dateOfBirthStr) {
  const moment = Moment(dateOfBirthStr);

  if (moment.isValid()) {
    const today = new Date();
    const dateOfBirth = moment.toDate();
    let age = today.getFullYear() - dateOfBirth.getFullYear();
    const additionalMonths = today.getMonth() - dateOfBirth.getMonth();

    if (additionalMonths < 0 || (additionalMonths === 0 && today.getDate() < dateOfBirth.getDate())) {
      age--;
    }

    return age >= 18;
  } else return false;
}
